import { __decorate } from "tslib";
import { html } from 'lit';
import { CipublicElement } from '@cigna/cigna_csg_gsg_cipublic-shared/lib/mixins/base.js';
import { state, query } from 'lit/decorators.js';
import { isIosDevice } from '@cigna/cigna_csg_gsg_cipublic-shared/lib/utils/browser-detection.js';
import { debounce } from '@cigna/cigna_csg_gsg_cipublic-shared/lib/utils/debounce.js';
import { InternalI18n } from '@cigna/cigna_csg_gsg_cipublic-shared/lib/i18n/internal-i18n-controller.js';
import styles from './back-to-top-button.scss.js';
import '@cigna/cigna_csg_gsg_cipublic-backdrop/cipublic-backdrop.js';
import '@cigna/cigna_csg_gsg_cipublic-icon/cipublic-icon.js';
/**
 * cipublic-back-to-top-button
 *
 * @csspart button - the button element
 */
export class BackToTopButton extends CipublicElement {
    constructor() {
        super(...arguments);
        this.i18n = new InternalI18n(this);
        this.active = false;
    }
    static get styles() {
        return [styles];
    }
    connectedCallback() {
        super.connectedCallback();
        window.addEventListener('scroll', debounce(this.showButton.bind(this), 200));
    }
    showButton() {
        if (window.scrollY !== 0) {
            this._container.classList.add('show');
            this._container.setAttribute('aria-hidden', 'false');
        }
        else {
            this._container.classList.remove('show');
            this._container.setAttribute('aria-hidden', 'true');
        }
    }
    triggerScrollToTop() {
        const scrollOptions = {
            top: 0,
            left: 0,
            behavior: 'smooth',
        };
        window.scrollTo(scrollOptions);
        this.active = true;
        document.body.style.overflowY = 'auto';
        this._button.blur();
        const checkScrollLocation = () => {
            if (window.scrollY === 0) {
                this.active = false;
                clearInterval(interval);
                this._container.classList.remove('show');
                this._container.setAttribute('aria-hidden', 'true');
                location.href = '#'; // Reset focus to first focusable element
            }
        };
        const interval = setInterval(checkScrollLocation.bind(this), 75);
    }
    disconnectedCallback() {
        super.disconnectedCallback();
        window.removeEventListener('scroll', debounce(this.showButton.bind(this), 200));
    }
    render() {
        return html `<div class="container" @click="${() => {
            if (isIosDevice()) {
                setTimeout(() => window.scrollTo(0, 1), 100);
                this.triggerScrollToTop();
                // call this manually because it won't get triggered via `triggerScrollToTop`
                this.active = false;
                this._container.classList.remove('show');
                this._container.setAttribute('aria-hidden', 'true');
            }
            else {
                this.triggerScrollToTop();
            }
        }}"><button class="btt-button"><cipublic-icon set="system" name="chevron-up"></cipublic-icon>${this.i18n.t('backToTop')}</button><div class="shadow"></div></div><cipublic-backdrop inverted ?active="${this.active}"></cipublic-backdrop>`;
    }
}
__decorate([
    state()
], BackToTopButton.prototype, "active", void 0);
__decorate([
    query('.container')
], BackToTopButton.prototype, "_container", void 0);
__decorate([
    query('.btt-button')
], BackToTopButton.prototype, "_button", void 0);
//# sourceMappingURL=back-to-top-button.js.map